import { render, staticRenderFns } from "./sub-request-info.vue?vue&type=template&id=25d18ae4&scoped=true&"
import script from "./sub-request-info.vue?vue&type=script&lang=js&"
export * from "./sub-request-info.vue?vue&type=script&lang=js&"
import style0 from "./sub-request-info.vue?vue&type=style&index=0&id=25d18ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d18ae4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow})
